import { useEffect } from 'react';
import * as React from 'react';

export interface FunctionVideoProps {
  /**
   * Additional classname to use for the alt Image tag.
   */
  className: string;
  /**
   * Url path to a .webm video showing the functionality
   * of the app.
   */
  videoSrc: string;
  /**
   * An alternative Image to use, when the video cannot be
   * loaded or when beeing on Safari browser.
   * (Safari browser does not support webm-videos.)
   */
  altImgSrc: string;
}

const FunctionVideo: React.FC<FunctionVideoProps> = ({ className, videoSrc, altImgSrc }) => {
  const [isSafariOrIOs, setIsSafariOrIOs] = React.useState(false);

  useEffect(() => {
    let ua;
    if (window && navigator && navigator.userAgent) {
      ua = navigator.userAgent.toLocaleLowerCase();
      const isSafOrIOs = ua && ua.indexOf('safari') !== -1 && !(ua.indexOf('chrome') > -1);
      setIsSafariOrIOs(isSafOrIOs);
    } else {
      setIsSafariOrIOs(false);
    }
  }, []);

  return (
    <>
      <div style={isSafariOrIOs ? undefined : { display: 'none' }}>
        <img className={className} alt="transcription function" src={altImgSrc} />
      </div>
      <div style={!isSafariOrIOs ? undefined : { display: 'none' }}>
        <video className={className} autoPlay muted loop playsInline>
          <source src={videoSrc} type="video/webm" />
        </video>
      </div>
    </>
  );
};

export default FunctionVideo;
